import React, { useEffect, useState } from "react";
import Otp from "../../GenerateOtp/Otp/Otp";
import LanguageTranslater from "../../HOC/LanguageTranslater";
import { CAPS_Y, GENERATE_OTP_ATTEMPTS_ALLOWED, ROUTES, TELEBINDING_STAGES, YES } from "../../../utils/constants";
import { Badge, Button } from "unified-ui-components-library";
import { useHistory } from "react-router-dom";
import { secureIcn } from "../../../images/TeleBindingImages/TeleBindingImages";
import ProposalVerification from "../../POSV_New_Ui/ProposalVerification/ProposalVerification";
import AxiosRequest from "../../../utils/axios";
import { getApiData } from "../../../api/api";
import '../Telebinding.css'
import DotsLoader from "../../Loader/DotsLoader/DotsLoader";
import { getRedirectionRouteForPosv } from "../../../utils/handleProgress";
import VideoSubmission from "../../POSV_New_Ui/VideoSubmission/VideoSubmission";


const axios = new AxiosRequest().getClient();

const TelebindingOTP = ({ translate }) => {
    const router = useHistory();
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOtp] = useState("");
    const [wrongOtpErr, setWrongOtpErr] = useState(false)
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false)
    const [autoFilledOtp, setAutoFilledOtp] = useState("")
    const [countdown, setCountdown] = useState(59);
    const [otpSentCount, setOtpSentCount] = useState(0);
    const [otpSentMsg, setOtpSentMsg] = useState('');
    const [showProposalScreen, setShowProposalScreen] = useState(false);
    const [proposerName, setProposerName] = useState("");
    const [disableResend, setDisableResend] = useState(false);
    const [wrongOtpErrMsg, setWrongOtpErrMsg] = useState("");
    const [currentStage, setCurrentStage] = useState("");
    const [showVideoSubmission, setShowVideoSubmission] = useState(false);
    
    useEffect(() => {
        const name = sessionStorage.getItem("proposerFirstname");
        if (name) setProposerName(name);
        getOtp();

    }, []);

    useEffect(() => {
        let timer;
        if (disableResend && countdown > 0) {
            timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
        } else if (countdown === 0) {
            setDisableResend(false);
        }
        return () => clearTimeout(timer);
    }, [countdown, disableResend]);

    const inputFunction = () => {
        const inputs = document.querySelectorAll(".input_otp");
        const [i0, i1, i2, i3, i4, i5] = inputs;

        if (wrongOtpErr) {
            setWrongOtpErr(false);
            setWrongOtpErrMsg("");
            setOtp("");
            inputs.forEach(input => input.value = "");
            setIsSubmitEnabled(false);
            return;
        }
        if (i0.value && i1.value && i2.value && i3.value && i4.value && i5.value) {
            const otpVal = `${i0.value}${i1.value}${i2.value}${i3.value}${i4.value}${i5.value}`
            setOtp(otpVal)
            setIsSubmitEnabled(true)
        } else {
            setIsSubmitEnabled(false)
        }
    }

    const getOtp = async () => {
        const posvRef = localStorage.getItem("posvRefNumber");
        try {
            let { url, body } = getApiData("getOtp");
            body = JSON.parse(JSON.stringify(body));

            body.request.payload = {
                posvRefNumber: posvRef,
                authToken: "",
                onCallOTP: "No",
                lang: "English",
                journeyBy: localStorage.getItem("journeyBy"),
                regenerateOTP:
                    otpSentCount >= GENERATE_OTP_ATTEMPTS_ALLOWED ? "Y" : "N",
            };

            setDisableResend(true);
            setCountdown(59);
            setOtpSentCount((prev) => prev + 1);

            const response = await axios.post(url, body);
            const payload = response.data.response?.payload;

            setOtpSentMsg(
                payload?.levelMessage ||
                payload?.businessMsg ||
                translate("OTP sent successfully to your registered number")
            );

        } catch (err) {
            console.error("OTP API Error:", err);
            setOtpSentMsg("Something went wrong, please try again.");
            setDisableResend(false);
        }
    };

    const handleOtpSubmit = async () => {
        const posvRef = localStorage.getItem("posvRefNumber");
        setIsSubmitting(true);
        setWrongOtpErr(false);
        setWrongOtpErrMsg("");
        setLoading(true);
        try {
            const { url, body } = getApiData("validateOtp");

            body.request.payload = {
                posvRefNumber: posvRef,
                otp,
                authToken: "",
                autoFilledOtp: "N",
                journeyBy: localStorage.getItem("journeyBy"),
                verificationSource: localStorage.getItem("verificationSource"),
                planCode: localStorage.getItem("planCode"),
                validateOtpForTbLink: "Y"
            };

            const response = await axios.post(url, body);
            const payload = response.data?.response?.payload;
            const msgCode = response.data?.response?.messageInfo?.msgCode;
            const businessMsg = payload?.businessMsg;

            if (msgCode === "200") {
                const currentTeleBStage = response?.data?.response?.payload?.teleBStage;
                const renewalStatus = response?.data?.response?.payload?.renewalStatus;
                const initialStatus = response?.data?.response?.payload?.initialStatus;
                sessionStorage.setItem("tbStageOnOtp", currentTeleBStage);
                sessionStorage.setItem("renewalStatusOnOtp", renewalStatus);
                sessionStorage.setItem("initialStatusOnOtp", initialStatus);
                setCurrentStage(currentTeleBStage);
                setIsSubmitting(false);
                setShowVideoSubmission(true);

            } else {
                setWrongOtpErr(true);
                setIsSubmitting(false);
                setWrongOtpErrMsg(payload?.businessMsg);
            }


        } catch (err) {
            console.error("OTP Validation Error:", err);
            setWrongOtpErrMsg("Something went wrong");
            setWrongOtpErr(true);
        } finally {
            setLoading(false);
        }
    }

    const onProceed = () => {
        let url = ROUTES.WAITING;
        if (currentStage === TELEBINDING_STAGES.POSV) {
            url = getRedirectionRouteForPosv();
        }

        if (currentStage === TELEBINDING_STAGES.PAYMENT || currentStage === TELEBINDING_STAGES.PAYMENT_PROCESSING) {
            url = ROUTES.PAYMENT
        }

        if (currentStage === TELEBINDING_STAGES.PII) {
            url = ROUTES.PERSONAL_DETAILS
        }

        console.log({url})
        router.push(url)
    }
    
    if (showVideoSubmission) {
    return (
      <VideoSubmission
        messageTxt="Verified Successfully!"
        redirectionMsg="Redirecting to verification journey..."
        redirectToPage={()=>{
            setShowProposalScreen(true)
            setShowVideoSubmission(false)
        }}
        isTelebinding= {true}
      />
    );
  }


    if (showProposalScreen) {
        return (
            <ProposalVerification isTelebinding={CAPS_Y} isPhoneBanking={sessionStorage.getItem('isPhoneBanking') === CAPS_Y} onProceed={onProceed} currentStage={currentStage} />
        );
    }

    return (
        <>
            {loading && <DotsLoader msg={"Please wait..."} />}
            <div className="welcomePage">
                <div className="welcomeMessage">
                    <div className="proposerName">
                        <p>Hi {proposerName || "User"}</p>
                    </div>
                    <div className="welcomeText">
                        <div className="welcomeTextIntro">

                            <div className="welcomeAxis">
                                <p>Welcome to Axis Max Life</p>
                                <p>Proposal Verification</p>
                            </div>

                            <div className="proposalIntro">
                                <p id="proposal-number">Proposal no.{localStorage.getItem("policyNumber")}</p>
                                <p id="plus-plan">{localStorage.getItem("productName")}</p>
                            </div>
                        </div>

                    </div>

                    <Badge
                        className="content"
                        size="default"
                        state="success"
                        style="simple"
                        variant="badge"
                        width="max-content"
                    >
                        <span id="badge-icon"><img src={secureIcn} alt="Success Icon" className="union-img" /></span>  <p> Your data is 100% safe</p>
                    </Badge>
                </div>
                <div className="otpContainer">
                    <div className="teleOtpContainer">
                        <div className="teleOtp-wrap">
                            <div className="teleOtp-generate">
                                <div>
                                    <p className="enter-otp-authenticate">{translate("Enter OTP to Authenticate")}</p>
                                    <div className="otp-sent-message">{otpSentMsg && <p>{otpSentMsg}</p>}</div>

                                </div>
                                <div className="otpandBtn">
                                    <div
                                        className="otpContainerRow"
                                    >
                                        <Otp
                                            submitting={isSubmitting}
                                            inputFunction={inputFunction}
                                            wrongOtpErr={wrongOtpErr}
                                            autofilledOtpFunction={(value) => setAutoFilledOtp(value)}
                                            removeWrongOtpClass={() => {
                                                setWrongOtpErr(false)
                                            }}
                                            isTelebindingJourney={true}
                                        />

                                    </div>
                                    {wrongOtpErr &&
                                        <div className="wrongOtpTxt">
                                         <p className="error-text">{wrongOtpErrMsg}</p>
                                        </div>}
                                    <div className="buttons_div__otp">
                                        <div className="btn-time">
                                            {
                                                otpSentCount === GENERATE_OTP_ATTEMPTS_ALLOWED ? <>
                                                    <p className='small-txt'>You have exceeded all your attempts to receive OTP, please contact the helpdesk No. 1800 121 8143/ 1800 102 8672</p>
                                                </> :
                                                    <p className='teleotptime'>
                                                        {
                                                            otpSentCount >= GENERATE_OTP_ATTEMPTS_ALLOWED ? (
                                                                <span className='small-txt'>
                                                                    You have exceeded all your attempts to receive OTP. Please contact the helpdesk at 1800 121 8143 / 1800 102 8672.
                                                                </span>
                                                            ) : disableResend ? (
                                                                <>
                                                                    You can resend OTP in{" "}
                                                                    <span className='green-time telebinding'>
                                                                        {countdown < 10 ? `0${countdown}` : countdown} seconds
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <span
                                                                    className='link_view_resend_otp_btn'
                                                                    onClick={getOtp}
                                                                >
                                                                    Resend OTP
                                                                </span>
                                                            )
                                                        }
                                                    </p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button_div_unified">
                                <Button
                                    className="submit_button--generate_otp"
                                    onClick={handleOtpSubmit}
                                    disabled={!isSubmitEnabled}
                                    buttonType="primary"
                                    width="264"
                                >
                                    {translate("Submit")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LanguageTranslater(TelebindingOTP);